import { render, staticRenderFns } from "./MusicCard.vue?vue&type=template&id=f436d082&scoped=true"
import script from "./MusicCard.vue?vue&type=script&lang=ts"
export * from "./MusicCard.vue?vue&type=script&lang=ts"
import style0 from "./MusicCard.vue?vue&type=style&index=0&id=f436d082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f436d082",
  null
  
)

export default component.exports